import { render, staticRenderFns } from "./ListAttachmentTypePage.vue?vue&type=template&id=6d59df70&"
import script from "./ListAttachmentTypePage.vue?vue&type=script&lang=js&"
export * from "./ListAttachmentTypePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports